// extracted by mini-css-extract-plugin
export var active = "_2q-7";
export var backButton = "_2q-6";
export var clone = "_2q-c";
export var collapseBar = "_2q-h";
export var collapseMode = "_2q-j";
export var dragHandle = "_2q-a";
export var dropdownIcon = "_2q-e";
export var hidden = "_2q-p";
export var iconContainer = "_2q-m";
export var iconSwapper = "_2q-o";
export var navItem = "_2q-4";
export var navItemIcon = "_2q-d";
export var navProfile = "_2q-5";
export var notificationCountBadge = "_2q-g";
export var notificationDot = "_2q-n";
export var optionsContainer = "_2q-f";
export var primaryNav = "_2q-0";
export var primaryTab = "_2q-k";
export var secondaryNav = "_2q-1";
export var selected = "_2q-l";
export var settingsNav = "_2q-2";
export var settingsNavItems = "_2q-3";
export var show = "_2q-b";
export var sideNav = "_2q-i";
export var teamItem = "_2q-8";
export var userProfileItem = "_2q-9";